import { SvgIconProps } from './icon-props';

export default function ChevronLightRight({ height = 20, width = 20 }: SvgIconProps) {
	return (
		<svg
			width={width}
			height={height}
			viewBox="0 0 20 20"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M5 18.6583L5.00302 20L15 9.99429L5.00302 0V1.32617L13.6988 9.99429L5 18.6583Z"
				fill="black"
			/>
		</svg>
	);
}
